import * as React from "react";
import type { ComponentProps } from "react";
import { cn } from "app/javascript/utils/index";
import {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
} from "app/javascript/components/ui/shadcn/card";

function AppCardTitle({ className, ...props }: ComponentProps<typeof CardTitle>) {
  return <CardTitle className={cn("text-2xl tracking-tight", className)} {...props} />;
}

const AppCard = Card;
const AppCardHeader = CardHeader;
const AppCardFooter = CardFooter;
const AppCardAction = CardAction;
const AppCardDescription = CardDescription;
const AppCardContent = CardContent;

export {
  AppCard,
  AppCardHeader,
  AppCardFooter,
  AppCardTitle,
  AppCardAction,
  AppCardDescription,
  AppCardContent,
};
